import styled from "styled-components";
import{Link as LinkR} from 'react-router-dom'
import{Link as LinkS} from 'react-scroll'

export const Button=styled(LinkR)`
border-radius: 50px;
background: ${({primary})=>(primary?'#13588c':'#010606')};
white-space: nowrap;
padding: ${({big})=>(big?'14px 48px':'12px 30px')};
color: ${({dark})=>(dark?'#a5ff36':'#010606')};
font-size: ${({fontBig})=>(fontBig?'20px':'16px')};
outline: none;
text-decoration: none;
font-weight: bold;
border: none;
cursor: pointer;
display: flex;
justify-content: center;
align-items: center;
transition: all 0.2s ease-in-out;

&:hover{
    transition: all 0.2s ease-in-out;
    background: ${({primary})=>(primary?'#fff':'#010606')};
}
`
export const ButtonS=styled(LinkS)`
border-radius: 40px;
background: ${({primary})=>(primary?'#01BF71':'#010606')};
white-space: nowrap;
padding: ${({big})=>(big?'20px 48px':'12px 30px')};
color: ${({dark})=>(dark?'#010606':'#fff')};
font-size: ${({fontBig})=>(fontBig?'20px':'16px')};
outline: none;
border: none;
cursor: pointer;
display: flex;
justify-content: center;
align-items: center;
transition: all 0.2s ease-in-out;

&:hover{
    transition: all 0.2s ease-in-out;
    background: ${({primary})=>(primary?'#fff':'#010606')};
}
`